import { render } from "./FooterLink.vue?vue&type=template&id=67b576d0&ts=true"
import script from "./FooterLink.vue?vue&type=script&lang=ts"
export * from "./FooterLink.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__